import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import reviewsAPI from "../../modules/reviews/api"
import {recordEvent} from "../../modules/app/plugins/metricPlugin";
import Button from "./Button";

/**
 * A Button that cycles through smart response templates for a review.
 * It caches template responses and then on click it cycles through them.
 */
const SmartResponseButton = (props) => {
  const [index, setIndex] = useState(0);
  const [loading, setLoading] = useState(false);
  const [templates, setTemplates] = useState([]);
  const [clicksCounter, setCountClicks] = useState(1);

  useEffect(() => {
    if (templates.length > 0) selectTemplate();
  }, [templates]);

  const handleSmartResponseClick = () => {
    setCountClicks(clicksCounter + 1)
    if (props.disabled) return undefined;
    if (templates.length === 0) {
      fetchSmartResponseTemplates();
    } else {
      selectTemplate();
    }
    props.smartResponseClicksCounter(clicksCounter)
  };

  const fetchSmartResponseTemplates = () => {
    recordEvent("smartResponseButtonClick", {value: "Initial_click", reviewId: props.review.reviewId});
    props.onStartLoad();
    setLoading(true);
    reviewsAPI.generateReviewResponseTemplates(props.review.reviewId).then(resp => {
      setTemplates(resp);
      setLoading(false);
      props.onEndLoad();
    })
  };

  const selectTemplate = () => {
    const currentTemplateIndex = index % templates.length
    const template = templates[currentTemplateIndex];
    props.onSmartResponseReady(template, currentTemplateIndex);
    setIndex(index + 1);
  }

  return <Button icon="fas fa-hexagon" color="white" className={`btn btn-outline-info ${props.disabled || loading  ? "disabled" : ""}`} onClick={handleSmartResponseClick}>Suggest</Button>;
};

SmartResponseButton.propTypes = {
  review: PropTypes.object,
  onStartLoad: PropTypes.func,
  onEndLoad: PropTypes.func,
  onSmartResponseReady: PropTypes.func,
  disabled: PropTypes.bool,
  smartResponseClicksCounter: PropTypes.func
};

export default SmartResponseButton;
